import React from 'react';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

import List from './List';

const ListaExpositor = () => {
    document.title = "Lista de Expositores | EVOMAP - Tecnologia que conecta negócios";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Lista de Expositores" pageTitle="Expositores" />
                    <List />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ListaExpositor;